import { useTheme } from "@emotion/react";
import { Box, Button, Modal, Paper, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import ReactPlayer from "react-player";
import Quiz from "./Quiz";
import { useTranslation } from "react-i18next";

export default function VideoModal(props) {
  const { open, handleClose, link, finishVideo, infoText, title, videoQuestion } = props;

  const theme = useTheme();
  const isSuperSmall = useMediaQuery("(max-width:350px)");
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.down("md"));

  const {t, i18n} = useTranslation()

  const [showQuestion, setShowQuestion] = useState(false);

  const handleQuestionAnswered = () => {
    finishVideo();
    handleModalClose();
  };

  const handleVideoEnded = () => {
    setShowQuestion(true);
  };

  const handleVideoSkip = () => {
    setShowQuestion(true);
  }

  const handleRewatch = (e) => {
    setShowQuestion(false);
  };

  const handleModalClose = () => {
    handleClose();
    setShowQuestion(false);
  };

  const getWidthAndHeight = () => {
    if (isSuperSmall) {
      return [300, 168.75];
    } else if (isXs) {
      return [320, 180];
    } else if (isSm) {
      return [480, 270];
    } else {
      return [640, 360];
    }
  };

  const [width, height] = getWidthAndHeight();

  console.log(link)

  return (
    <Modal open={open} onClose={handleModalClose}>
      <Paper
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: { xs: 1, sm: 2 },
        }}
      >
        <Typography variant="h2" align="center">
          {title}
        </Typography>
        {i18n.language === "uk" && <Typography color="error">На жаль, поки що немає перекладу відео українською мовою. Але ми працюємо над цим!</Typography>}
        {infoText}
        {!showQuestion ? (
          <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <ReactPlayer
              url={link}
              controls
              onContextMenu={(e) => e.preventDefault()}
              onEnded={handleVideoEnded}
              width={width}
              height={height}
            />
            <Button onClick={handleVideoSkip} sx={{mt: 1}}>{t("videoSkip")}</Button>
          </Box>
        ) : (
          <Quiz
            question={videoQuestion.question}
            options={videoQuestion.options}
            answerIndex={videoQuestion.answerIndex}
            handleAnswered={handleQuestionAnswered}
            handleRewatch={handleRewatch}
          />
        )}
      </Paper>
    </Modal>
  );
}
